export default "__VITE_ASSET__D679el$x__"